/** 界面语言：英文默认，中文 / 印尼语手动切换 */
export type Locale = "en" | "zh" | "id";

/** 一条内容的三语文案，展示时按当前语言取其中一种 */
export type L10n = Record<Locale, string>;

/** 组装一条三语文案，数据层可同时保留 en / zh / id */
export function L(en: string, zh: string, id: string): L10n {
  return { en, zh, id };
}

/** 按当前语言取出展示文案；纯字符串则原样返回 */
export function pick(text: L10n | string | undefined, locale: Locale): string {
  if (!text) return "";
  return typeof text === "string" ? text : text[locale];
}

/**
 * 替换模板里的 {name}。
 * 英文数量 n 恰好为 1 时，把 Dream Beans 收成单数 Dream Bean。
 */
export function fill(template: string, vars: Record<string, string | number>): string {
  const filled = template.replace(/\{(\w+)\}/g, (_, key: string) => (vars[key] === undefined ? "" : String(vars[key])));
  return singularDreamBean(filled, vars.n);
}

/** 数量为 1 时用单数。中文和印尼语模板不含该词，不会被改到。 */
function singularDreamBean(text: string, count: string | number | undefined): string {
  if (!isOne(count)) return text;
  return text.replace(/\bDream Beans\b/g, "Dream Bean");
}

/** 占位数量是否恰好为 1 */
function isOne(count: string | number | undefined): boolean {
  if (count === undefined || count === "") return false;
  const n = typeof count === "number" ? count : Number(String(count).trim());
  return n === 1;
}

/** 搜索命中任一语言的原文，不按当前界面语言过滤 */
export function matchesAny(text: L10n | string, query: string): boolean {
  const q = query.trim().toLowerCase();
  if (!q) return false;
  const source = typeof text === "string" ? text : `${text.en}\n${text.zh}\n${text.id}`;
  return source.toLowerCase().includes(q);
}
